import { memo } from 'react';
import { cn, RawHtml } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import styles from './Properties.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface PropertiesProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  properties: string[];
}

const Properties: FC<PropertiesProps> = (props) => {
  const { className, properties, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      <div className={styles.items}>
        <div className={styles.label}>{t('properties-label')}</div>
        <RawHtml html={properties.join(', ')} />
      </div>
    </div>
  );
};

export default memo(Properties);
